import { render, staticRenderFns } from "./CreateEditCovenants.vue?vue&type=template&id=1273134a&"
import script from "./CreateEditCovenants.vue?vue&type=script&lang=js&"
export * from "./CreateEditCovenants.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditCovenants.vue?vue&type=style&index=0&id=1273134a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports